var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artwork, partner, user) {
partner = artwork.related().partner
buf.push("<h1 class=\"iq-headline\">");
if ( partner.get('pre_qualify'))
{
buf.push("" + (jade.escape((jade_interp = partner.get('name')) == null ? '' : jade_interp)) + " asks for some additional information before placing an inquiry.\nYou only have to do this once.");
}
else
{
buf.push("Tell " + (jade.escape((jade_interp = partner.get('name')) == null ? '' : jade_interp)) + " a little bit about yourself.");
}
buf.push("</h1><form class=\"iq-form stacked-form\"><div class=\"iq-form-errors js-form-errors\"></div><label for=\"profession\" class=\"avant-garde-form-label\">Profession");
if ( partner.get('pre_qualify'))
{
buf.push("<span>(Required)</span>");
}
buf.push("</label><input name=\"profession\" id=\"profession\"" + (jade.attr("value", user.get('profession'), true, true)) + (jade.attr("required", partner.get('pre_qualify'), true, true)) + " class=\"bordered-input js-iq-profession\"><label for=\"location\" class=\"avant-garde-form-label\">Location");
if ( partner.get('pre_qualify'))
{
buf.push("<span>(Required)</span>");
}
buf.push("</label><div class=\"js-location-search\"></div><label for=\"phone\" class=\"avant-garde-form-label\">Phone Number");
if ( partner.get('pre_qualify'))
{
buf.push("<span>(Required)</span>");
}
buf.push("</label><input name=\"phone\" id=\"phone\" type=\"tel\"" + (jade.attr("value", user.get('phone'), true, true)) + (jade.attr("required", partner.get('pre_qualify'), true, true)) + " class=\"bordered-input js-iq-phone\">");
if ( user.isLoggedIn())
{
buf.push("<div class=\"iq-checkbox artsy-checkbox\"><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\" id=\"share_follows\" name=\"share_follows\"" + (jade.attr("checked", (user.has('share_follows') ? user.get('share_follows') : true), true, true)) + "><label for=\"share_follows\"></label></div><label for=\"share_follows\" class=\"artsy-checkbox--label\">Share followed artists, categories, and galleries</label></div>");
}
buf.push("<button type=\"submit\" class=\"avant-garde-button-black iq-next\">Next</button></form>");}.call(this,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;